(function () {
  const EXPERIMENT_ID = 'also-like-designer-ab';
  const CONTROL_GROUP = 'a';
  const EXPERIMENT_GROUP = 'b';

  if (window.__fabriqueYouMayAlsoLikeABInitialized) return;
  window.__fabriqueYouMayAlsoLikeABInitialized = true;

  function getGroup(timeout) {
    return new Promise(resolve => {
      const startedAt = Date.now();

      function check() {
        try {
          const value = window._growthbook?.getFeatureValue?.(EXPERIMENT_ID, null);
          if (value !== null && value !== undefined && value !== '') {
            const group = String(value).toLowerCase();
            resolve(group === EXPERIMENT_GROUP ? EXPERIMENT_GROUP : CONTROL_GROUP);
            return;
          }
        } catch (error) {
          resolve(CONTROL_GROUP);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          resolve(CONTROL_GROUP);
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function setCardAttribution(container, group) {
    container.querySelectorAll('.fabrique-product-wrapper').forEach(card => {
      card.dataset.abExperimentId = EXPERIMENT_ID;
      card.dataset.abGroup = group;
      card.dataset.abSlideFeatureId = EXPERIMENT_ID;
      card.dataset.abVariant = group;
      card.dataset.trackAbtestExperimentId = EXPERIMENT_ID;
      card.dataset.trackAbtestExperimentGroup = group;
      card.dataset.trackAddToCart = 'true';
    });
  }

  function trackModuleExposure(module, group, source) {
    if (module.dataset.youMayAlsoLikeExposed === 'true' || !window.$track) return;

    module.dataset.youMayAlsoLikeExposed = 'true';
    window.$track.track('expose', {
      event: 'ModuleExpose',
      moduleId: 'you_may_also_like',
      moduleType: 'list_horizontal',
      trackItems: [{
        abtestExperimentId: EXPERIMENT_ID,
        abtestExperimentGroup: group,
        recommendationSource: source,
      }],
    });
  }

  function initModule(module) {
    const control = module.querySelector('[data-you-may-also-like-control]');
    const designer = module.querySelector('[data-you-may-also-like-designer]');
    if (!control) return;

    setCardAttribution(control, CONTROL_GROUP);
    if (designer) setCardAttribution(designer, CONTROL_GROUP);

    getGroup(3000).then(group => {
      const showDesigner = group === EXPERIMENT_GROUP && designer;
      const visibleContainer = showDesigner ? designer : control;

      control.hidden = Boolean(showDesigner);
      if (designer) designer.hidden = !showDesigner;
      module.dataset.abGroup = group;
      module.dataset.youMayAlsoLikeSource = showDesigner ? 'designer' : 'recommendations';
      setCardAttribution(visibleContainer, group);
      trackModuleExposure(module, group, module.dataset.youMayAlsoLikeSource);

      const observer = new MutationObserver(() => {
        setCardAttribution(visibleContainer, group);
      });
      observer.observe(visibleContainer, { childList: true, subtree: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-you-may-also-like-module]').forEach(initModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
